<template>
    <div>
      <HeaderView :title="$t('mine.loginpwd')" />
      <div class="view-page">
        <van-form @submit="save">
          <van-cell-group>
            <van-field
              v-model="old_password"
              :label="$t('setting.old_pwd')"
              :placeholder="$t('setting.old_pwd_tip')"
              :rules="[{ required: true}]"
            />
            <van-field
              v-model="o_new_password"
              :label="$t('setting.new_pwd')"
              :placeholder="$t('setting.new_pwd_tip')"
              :rules="[{ required: true}]"
            />
            <van-field
              v-model="t_new_password"
              :label="$t('setting.new_pwd')"
              :placeholder="$t('setting.new_again_tip')"
              :rules="[{ required: true}]"
            />
          </van-cell-group>
  
          <div style="margin: 16px">
            <van-button class="btn" native-type="submit">{{
              $t("common.save")
            }}</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </template>
  
  <script>
  import HeaderView from "../../components/Header/index.vue";
  export default {
    name: "ChangeUsrPwdView",
    components: { HeaderView },
    data() {
      return {
        o_new_password: "",
        t_new_password: "",
        old_password: "",
      };
    },
    methods: {
      back() {
        return window.history.back();
      },
      save() {
        if (
          this.o_new_password === "" ||
          this.o_new_password === null ||
          this.o_new_password === undefined
        ) {
          this.$toast.fail(this.$t("setting.prefect"));
          return false;
        }
        if (
          this.t_new_password === "" ||
          this.t_new_password === null ||
          this.t_new_password === undefined
        ) {
          this.$toast.fail(this.$t("setting.prefect"));
          return false;
        }
        if (
          this.old_password === "" ||
          this.old_password === null ||
          this.old_password === undefined
        ) {
          this.$toast.fail(this.$t("setting.prefect"));
          return false;
        }
        if (this.o_new_password !== this.t_new_password) {
          this.$toast(this.$t("setting.pwd_error"));
          return false;
        }
        this.$http({
          method: "get",
          data: {
            old_password: this.old_password,
            new_password: this.o_new_password,
          },
          url: "user_set_paypw",
        }).then((res) => {
          if (res.code === 200) {
            this.$toast(res.msg);
            setTimeout(() => {
              localStorage.clear();
              this.$router.push("login");
            }, 500);
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      },
      getUserInfo() {
        this.$http({
          method: "get",
          url: "user_info",
        }).then((res) => {
          if (res.code === 200) {
            this.userInfo = res.data;
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      },
    },
    created() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/login" });
      } else {
        this.getUserInfo();
      }
    },
  };
  </script>
  <style lang="scss" scoped></style>
  